import { combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';
import { connectRouter } from 'connected-react-router';

import ui from './ui';
import auth from './auth';
import company from './company';
import services from './services';
import categories from './categories';
import serviceForm from './serviceForm';
import userArea from './userArea';
import task from './task';

const reducer = history => combineReducers({
  router: connectRouter(history),
  ui,
  auth,
  serviceForm,
  services,
  categories,
  company,
  task,
  userArea,
  intl: intlReducer,
});

export default reducer;
